import {
    optionNames,
    phoneToCall,
    scheduling,
    webAssistantOptions,
    optionIcons,
    form
} from '../../utils/variables';

function isDisplayOption(option) {
    for (const i of webAssistantOptions) {
        if (i === option) {
            return true;
        }
    }
    return false;
}
export function loadOptions() {
    const options = document.querySelectorAll('.option');

    for (const i of options) {
        if (!isDisplayOption(i.getAttribute('id')) && !i?.closest('.allQuestions__content')) {
            i.classList.add('hidden');
        }
    }
}

function convertToIcon(iconName) {
    let temp = iconName.trim().match(/[A-Z][a-z]+/g);
    let tempRs = temp.map(item => { return item.toLowerCase(); });
    return tempRs.join('-');
}

export function onLoadOption() {
    loadOptions();

    const menuIcons = {
        instant_quote: '<i class="menu-icon ri-file-list-3-line"></i>',
        schedule_consultation: '<i class="menu-icon ri-calendar-check-line"></i>',
        request_consultation: '<i class="menu-icon ri-calendar-check-line"></i>',
        non_surgical_services: '<i class="menu-icon ri-file-list-2-line"></i>',
        text_us: '<i class="menu-icon ri-chat-3-line"></i>',
        see_all_services: '<i class="menu-icon ri-function-line"></i>',
        procedure_eligibility: '<i class="menu-icon ri-checkbox-circle-line"></i>',
        call: '<i class="menu-icon ri-phone-line"></i>',
        book_appointment: '<i class="menu-icon ri-calendar-check-line"></i>',
        ask_a_question: '<i class="menu-icon ri-question-line"></i>',
        /* Custom options link out to a client-owned page and have no key of their own here. */
        custom_option: '<i class="menu-icon ri-external-link-line"></i>'
    };

    /* menuIcons has no entry for `custom_option-<id>`, and custom options usually have
       icon = null, so without a fallback this expression is `undefined` and gets
       stringified into the card as a literal "undefined" above the option name. */
    function optionIcon(key) {
        if (optionIcons[key]) return `<i data-feather=${convertToIcon(optionIcons[key])}></i>`;
        if (menuIcons[key]) return menuIcons[key];
        if (key.includes('custom_option-')) return menuIcons.custom_option;
        return '';
    }

    function checkOption(value, key) {
        let option = optionIcon(key);
        if (key === 'book_appointment') {
            return option +=`<div>${value}</div>`;
        } else if (key.includes("custom_option-")) {
            let tempOptionId = parseInt(key.split('-')[1]);
            let optObj = form.widget_options.find(item => item.id === tempOptionId);
            if (optObj) {
                return option += `
                <a href="${optObj.url}" style="text-decoration: none; color: #333;" target="_blank">
                    ${value}
                </a>
                `;
            }
            return option += ``;
        } else {
            return option += `
            <div>${value}</div>
            `;
        }
    }

    let menu = '';
    const phoneNumbers = form?.main_phone_number || 
                        (form?.locations?.length === 1 ? form?.locations[0]?.phone : null) || 
                        phoneToCall;
    for (const [key, value] of Object.entries(optionNames)) {
        /* Skip options with no display name (e.g. deprecated FAQs) to avoid showing "undefined" */
        const displayValue = value ?? '';
        if (displayValue === '' && key !== 'call') continue;

        menu += `
            <div class="option" id="${key}">
                ${(key === 'call')
                ?
                `
                        <a href=${`tel:${phoneNumbers}`}>
                            ${optionIcons[key] ? `<i data-feather='${convertToIcon(optionIcons[key])}' class='feather-20'></i>` : (menuIcons[key] || '')}
                            ${displayValue}
                        </a>
                    `
                :
                checkOption(displayValue, key)
            }
            </div>
        `;
    }

    document
        .querySelector('.mainMenu__container .content__wrapper').insertAdjacentHTML(
            'beforeend',
            menu
        );
    feather.replace();
}
